import EmptyContent from '@components/General/EmptyContent';
import Header from '@components/mobile/Header';
import styles from '@styles/screens/mobile/MobileDashboard.module.css';
import { useEffect, useState } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import { useAuth } from '@contexts/authContext';

import MobileSidebar from '@components/mobile/Sidebar';
import PresenteeismTableScreen from './PresenteeismTableControlBoard';
import { useSelectedOrganization } from '@contexts/useSelectedOrganization';


const routingConfig = {
    Listado: {
        path: '/listado',
        flag: 'hasPresenteeismTable',
    }
}

const MobileDashboard = () => {

    const {orgs, updateUserRole} = useAuth();

    const [hamburgerOpen, setHamburgerOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const [clickedID, setClickedID] = useState('');
    const { selectedOrganization: org, setSelectedOrganization: setOrg } = useSelectedOrganization(orgs);
    const navigate = useNavigate();

    useEffect(() => {
        if (!org) return;
        updateUserRole(org.id);
    }, [org]);

    useEffect(() => {
        if (!org) {
            return;
        }

        let path = '/';
        // Merge flags and newFlags into a single object for easier checking
        const mergedFlags = { ...org.flags, ...org.newFlags };

        if (routingConfig[clickedID] && mergedFlags[routingConfig[clickedID].flag]) {
            path = routingConfig[clickedID].path;
        }

        navigate(path);
    }, [clickedID, org])

    const handleHamburgerClose = () => {
        setIsClosing(true);
        setTimeout(() => {
          setHamburgerOpen(false);
          setIsClosing(false);
        }, 300); // Match the timeout with the animation duration
    }

    const handleOverlayClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        handleHamburgerClose();
    };
    

    return (
    <div className={styles['main-screen']}>
        <Header hamburgerOpen={hamburgerOpen} onHamburgerClick={setHamburgerOpen} />
        <Routes>
            <Route path="/listado" element={<PresenteeismTableScreen org={org} />} />
            <Route path="*" element={<EmptyContent />} />
        </Routes>
        {hamburgerOpen && 
            <div className={styles.fade} onClick={handleOverlayClick}>
                <MobileSidebar defaultOrg={org} setOrg={setOrg} clickedID={clickedID} setClickedID={setClickedID} isClosing={isClosing} handleHamburgerClose={handleHamburgerClose}/>
            </div>
        }
    </div>
  );
}

export default MobileDashboard;
